// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'flag-check';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M.563 17.438V.563m0 14.657 2.365-.728a7.208 7.208 0 0 1 5.898.75 7.211 7.211 0 0 0 5.76.792l2.24-.64a.845.845 0 0 0 .612-.81V2.727a.844.844 0 0 0-1.076-.812l-1.777.508a7.212 7.212 0 0 1-5.759-.792 7.207 7.207 0 0 0-5.898-.75L.563 1.61' />
    <path d='M12.375 6.188 9 10.688l-2.25-2.25' />
  </g>
);

export const viewBox = '0 0 18 18';
